import React, { useState, useEffect } from 'react';
import styles from './Ticket.module.scss';
import { useDispatch, useSelector } from 'react-redux';
import {
    clearTicket,
    payWin,
    cancelTicket,
    sendReprintRequest,
    reprintTicket,
    getTicket,
} from '../../../../../store/actions/tickets';
import { setBarcodeScanned } from '../../../../../store/actions/global';
import { TICKET_STATUSES } from '../../../../../constants/enums';
import ContentSpinner from '../../../Spinner/Spinner';
import ModalHeading from '../../Heading/Heading';
import ModalCloseButton from '../../CloseButton/CloseButton';
import Button from '../../Button/Button';
import TicketInfo from './TicketInfo/TicketInfo';
import { toast } from 'react-toastify';
import { renderTicketStatusName, showSuccessNotification } from '../../../../../utils/render';
import { getTranslation } from '../../../../../utils/translation';
import { addTicketBetSlip, printTicket } from '../../../../../store/actions/betSlip';
import { useHistory } from 'react-router-dom';
const TicketResult = props => {
    const dispatch = useDispatch();
    const history = useHistory();
    const {
        ticket,
        loading: loadingTicket,
        ticketCode,
    } = useSelector(state => state.tickets.ticketModal);
    const { isBarcodeScanned } = useSelector(state => state.global);
    const cancelTicketResponse = useSelector(state => state.tickets.cancelTicket);
    const payWinResponse = useSelector(state => state.tickets.payWin);
    const maxPaymentAmount = useSelector(state => state.settings.account?.data?.maxPaymentAmount);
    const { isTicketSubmitting } = useSelector(state => state.betSlip);
    const userData = useSelector(state => state.settings.account?.data);

    const [isCancelDisabled, setIsCancelDisabled] = useState(false);
    const [isPayWinDisabled, setIsPayWinDisabled] = useState(false);
    const [reprintLoading, setReprintLoading] = useState(false);
    const [addToBetSlipLoading, setAddToBetSlipLoading] = useState(false);

    useEffect(() => {
        dispatch(getTicket(ticketCode));

        return () => {
            dispatch(setBarcodeScanned(false));
            dispatch(clearTicket());
        };
    }, []);

    const onReprintClick = async () => {
        setReprintLoading(true);
        try {
            const hasReprintAccess = !ticket?.printLimitExceeded;

            if (hasReprintAccess) {
                dispatch(reprintTicket(ticket.code));
            } else {
                const response = await dispatch(sendReprintRequest(ticket.code));

                if (response) {
                    showSuccessNotification(
                        getTranslation('ticketInformationReprintRequestSuccess'),
                    );
                }
            }
        } catch (error) {
            console.error(error);
        }
        setReprintLoading(false);
    };

    const onAddTicketBetSlipClick = async () => {
        setAddToBetSlipLoading(true);

        const response = await dispatch(addTicketBetSlip(ticket.code));

        setAddToBetSlipLoading(false);

        if (response.success) {
            props.closeModal();
            history.push('/app/sports');
        }
    };

    const onCancelClick = async () => {
        setIsCancelDisabled(true);
        const ticketData = await dispatch(cancelTicket(ticketCode));

        if (ticketData) {
            await printTicket(ticketData);
        }
    };

    const onPayWinClick = async () => {
        if (ticket.totalWinAmount > maxPaymentAmount) {
            toast.error(getTranslation('ticketInformationPayWinMaxPayAmountError'), {
                autoClose: 2000,
                hideProgressBar: true,
                closeOnClick: true,
            });
            return;
        }
        setIsPayWinDisabled(true);

        const ticketData = await dispatch(payWin(ticketCode, { ticketStatus: ticket.status }));

        if (ticketData) {
            const printData = { ...ticketData, ...ticketData.ticketResponse };
            delete printData.ticketResponse;
            await printTicket(printData);
        }
    };

    return (
        <>
            {loadingTicket ? (
                <div className={styles.loading}>
                    <ContentSpinner />
                </div>
            ) : (
                ticket && (
                    <>
                        <ModalHeading
                            statusId={ticket.status}
                            primary={renderTicketStatusName(ticket.status)}
                            secondary={`${getTranslation('ticketInformationHeaderBetType')} 
                                        ${ticket.ticketType}
                                        ${
                                            ticket.ticketType === 'SYSTEM'
                                                ? ticket.systemValues.trim().split(' ').join(', ')
                                                : ''
                                        }
                                            `}
                        >
                            <ModalCloseButton light onClick={() => props.closeModal()} />
                        </ModalHeading>
                        <TicketInfo ticket={ticket} />
                        <div className={styles.actions}>
                            {ticket.status === TICKET_STATUSES.open ? (
                                <div className={'flex'}>
                                    {/*<Button*/}
                                    {/*    disabled*/}
                                    {/*    width='165px'*/}
                                    {/*    marginRight='20px'*/}
                                    {/*    primary*/}
                                    {/*    large*/}
                                    {/*    title={'Cash out'}*/}
                                    {/*/>*/}
                                    <Button
                                        disabled={
                                            cancelTicketResponse.loading ||
                                            isCancelDisabled ||
                                            !ticket.cancellationAvailability ||
                                            !isBarcodeScanned ||
                                            ticket.mobileUserCode
                                        }
                                        onClick={onCancelClick}
                                        marginRight='37px'
                                        danger
                                        large
                                        title={
                                            cancelTicketResponse.loading
                                                ? getTranslation('ticketInformationCancelLoading')
                                                : getTranslation('ticketInformationCancelButton')
                                        }
                                    />
                                    {cancelTicketResponse.error &&
                                        cancelTicketResponse.error.errors.map(error => (
                                            <div className={styles.actionError} key={error}>
                                                {error.reason}
                                            </div>
                                        ))}
                                    {/*<Button*/}
                                    {/*    disabled*/}
                                    {/*    large*/}
                                    {/*    width='167'*/}
                                    {/*    style={{ marginLeft: 'auto', backgroundColor: '#3a3e4d' }}*/}
                                    {/*    title={'Copy Ticket'}*/}
                                    {/*/>*/}
                                </div>
                            ) : null}
                            {ticket.status === TICKET_STATUSES.won ||
                            ticket.status === TICKET_STATUSES.draw ||
                            ticket.status === TICKET_STATUSES.void ||
                            ticket.status === TICKET_STATUSES.refunded ||
                            ticket.status === TICKET_STATUSES.cashOut ? (
                                <div className={'flex flex-column'}>
                                    <Button
                                        disabled={
                                            payWinResponse.loading ||
                                            isPayWinDisabled ||
                                            !ticket.paymentAvailability ||
                                            !isBarcodeScanned
                                        }
                                        onClick={onPayWinClick}
                                        marginRight='20px'
                                        danger
                                        large
                                        title={getTranslation('ticketInformationPayWinButton')}
                                    />
                                    {payWinResponse.error &&
                                        payWinResponse.error.errors.map(error => (
                                            <div className={styles.actionError} key={error}>
                                                {error.reason}
                                            </div>
                                        ))}
                                </div>
                            ) : null}
                            <div />
                            <div className={'flex'}>
                                {ticket.betLines.every(
                                    betLine => TICKET_STATUSES.open === betLine.status,
                                ) ? (
                                    <Button
                                        disabled={addToBetSlipLoading || isTicketSubmitting}
                                        onClick={onAddTicketBetSlipClick}
                                        className={'m-r-4'}
                                        title={getTranslation(
                                            'ticketInformationAddToBetSlipButton',
                                        )}
                                    />
                                ) : null}
                                {(!ticket.mobileUserCode ||
                                ticket.status === TICKET_STATUSES.paid) && ticket.cashier === userData.accountNumber ? (
                                    <Button
                                        disabled={reprintLoading}
                                        onClick={onReprintClick}
                                        large
                                        info
                                        title={
                                            ticket?.printLimitExceeded
                                                ? getTranslation(
                                                      'ticketInformationReprintRequestButton',
                                                  )
                                                : getTranslation('ticketInformationReprintButton')
                                        }
                                    />
                                ) : null}
                            </div>
                        </div>
                    </>
                )
            )}
        </>
    );
};

export default TicketResult;
